/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  GetAnnouncementResponse,
  GetAnnouncementResponseFromJSON,
  GetAnnouncementResponseToJSON,
  GetAnnouncementsResponse,
  GetAnnouncementsResponseFromJSON,
  GetAnnouncementsResponseToJSON
} from '../models'

export interface UserV1AnnouncementsAnnouncementIdGetRequest {
  announcementId: string
}

export interface UserV1AnnouncementsGetRequest {
  page?: number
  per?: number
}

/**
 *
 */
export class ApiUserV1AnnouncementApi extends runtime.BaseAPI {
  /**
   * 指定したIDのお知らせを取得する
   * show
   */
  async userV1AnnouncementsAnnouncementIdGetRaw(
    requestParameters: UserV1AnnouncementsAnnouncementIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetAnnouncementResponse>> {
    if (requestParameters.announcementId === null || requestParameters.announcementId === undefined) {
      throw new runtime.RequiredError(
        'announcementId',
        'Required parameter requestParameters.announcementId was null or undefined when calling userV1AnnouncementsAnnouncementIdGet.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/announcements/{announcement_id}`.replace(
          `{${'announcement_id'}}`,
          encodeURIComponent(String(requestParameters.announcementId))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetAnnouncementResponseFromJSON(jsonValue))
  }

  /**
   * 指定したIDのお知らせを取得する
   * show
   */
  async userV1AnnouncementsAnnouncementIdGet(
    requestParameters: UserV1AnnouncementsAnnouncementIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<GetAnnouncementResponse> {
    const response = await this.userV1AnnouncementsAnnouncementIdGetRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * お知らせ一覧を取得する
   * index
   */
  async userV1AnnouncementsGetRaw(
    requestParameters: UserV1AnnouncementsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetAnnouncementsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.per !== undefined) {
      queryParameters['per'] = requestParameters.per
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/announcements`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetAnnouncementsResponseFromJSON(jsonValue))
  }

  /**
   * お知らせ一覧を取得する
   * index
   */
  async userV1AnnouncementsGet(
    requestParameters: UserV1AnnouncementsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<GetAnnouncementsResponse> {
    const response = await this.userV1AnnouncementsGetRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * 最新のお知らせを取得する
   * latest
   */
  async userV1AnnouncementsLatestGetRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetAnnouncementResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/announcements/latest`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetAnnouncementResponseFromJSON(jsonValue))
  }

  /**
   * 最新のお知らせを取得する
   * latest
   */
  async userV1AnnouncementsLatestGet(
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<GetAnnouncementResponse> {
    const response = await this.userV1AnnouncementsLatestGetRaw(initOverrides)
    return await response.value()
  }
}
